import type { AdType } from './adTypes';
import { adTypes } from './adTypes';
import { publisher } from './publisher';

export type AdTypePublisherRestrictionConfig = {
  exclude: string[];
};

export const AD_TYPE_PUBLISHER_RESTRICTIONS_MAP: Partial<Partial<Record<AdType, AdTypePublisherRestrictionConfig>>> = {
  [adTypes.PAUSE.key]: {
    exclude: [publisher.DISNEY_PLUS.key, publisher.ESPN.key, publisher.FUBO_TV.key],
  },
  [adTypes.GATEWAY_GO.key]: {
    exclude: [publisher.DISNEY_PLUS.key, publisher.ESPN.key, publisher.FUBO_TV.key],
  },
};
